/**
 * NotificationToggle component
 * This component allows users to toggle a notifications viewed state.
 * It uses the `useNotifications` hook to access the notifications context.
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

// const readIcon = <FontAwesomeIcon icon={icon({ name: 'circle-check', style: 'solid' })} />;
const readIcon = <FontAwesomeIcon icon={icon({ name: 'eye', style: 'regular' })} />;
// const unreadIcon = <FontAwesomeIcon icon={icon({ name: 'circle-check', style: 'regular' })} />;
const unreadIcon = (
  <FontAwesomeIcon icon={icon({ name: 'eye-slash', style: 'regular' })} className="text-pursuit-gray" />
);

const loadingIcon = <FontAwesomeIcon icon={icon({ name: 'spinner-third', style: 'solid' })} spin />;

// const NotificationToggle = ({ notificationId, isRead = false, unRead }) => {
const NotificationToggle = ({ readAt = null, loading = false }) => {
  // const { toggleNotificationViewed } = useNotifications();
  // const [isRead, setIsRead] = React.useState(defaultRead);

  // const handleToggle = useCallback(
  //   e => {
  //     // e.preventDefault();
  //     // console.log(`Toggling notification ${notificationId} viewed state from ${isRead} to ${!isRead}`);
  //     // setIsRead(!isRead);
  //     // unRead();
  //   },
  //   [notificationId]
  // );
  const title = readAt ? `Read at ${readAt}` : 'Mark as Read';

  return (
    <button title={title} /*onClick={handleToggle}*/ className="notification-toggle">
      {loading ? loadingIcon : !readAt ? readIcon : unreadIcon}
    </button>
  );
};
NotificationToggle.propTypes = {
  // notificationId: PropTypes.string.isRequired,
  isRead: PropTypes.string,
  // unRead: PropTypes.func.isRequired,
};

export default NotificationToggle;
